import md5 from 'md5'

if (!String.prototype.format) {
  /* eslint-disable no-extend-native */
  String.prototype.format = function () {
    var args = arguments
    return this.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] !== 'undefined' ? args[number] : match
    })
  }
}

if (location.protocol === 'https:' && navigator.serviceWorker) {
  navigator.serviceWorker.register('/service-worker.js')
}

window.getConfig = function () {
  return {
    // TODO: BU alan düzenlenmeli
    mod:
      window.location.hostname === 'localhost' ||
      window.location.hostname === 'test.eurekosigorta.com.tr' || window.location.hostname === 'mtest.eurekosigorta.com.tr' ||
      window.getRecaptchaInfo() === 'off'
        ? 'dev' : 'prod',
    // recaptchaKey: '6Le93o8UAAAAAAEXPlAgXTB-1SVYolGiF-g57mAb'
    recaptchaKey: '6LdUqnMUAAAAAP8IOjjMswXJV9TN3vwX7ArCTx7k',
    googleTagManagerKey: (window.location.hostname === 'eurekosigorta.com.tr' || window.location.hostname === 'www.eurekosigorta.com.tr' || window.location.hostname === 'sube.eurekosigorta.com.tr' || window.location.hostname === 'msube.eurekosigorta.com.tr' || window.location.hostname === 'dogus.eurekosigorta.com.tr' || window.location.hostname === 'kibarholding.eurekosigorta.com.tr')
      ? 'GTM-5KQ359Q' : 'GTM-WDNND3H'
  }
}

window.localAndTestHostNames = function () {
  var hostnames = ['localhost', 'testv2.eurekosigorta.com.tr', 'mtestv2.eurekosigorta.com.tr', 'testv3.eurekosigorta.com.tr', 'mtestv3.eurekosigorta.com.tr', 'beta.eurekosigorta.com.tr', 'mbeta.eurekosigorta.com.tr', 'test.eurekosigorta.com.tr', 'mtest.eurekosigorta.com.tr']
  return hostnames
}

var customer = {
  customerNo: 0,
  name: '',
  surname: '',
  fullName: '',
  birthDate: null,
  identity: '',
  mobilePhone: '',
  businessPhone: '',
  email: '',
  communication: {
    phoneNumber: '',
    email: '',
    fullAddress: '',
    address: '',
    info: null
  }
}

var agencyAuthorizations = {
  webLogin: false,
  allBranches: false,
  blPage: false,
  uploadDemand: false,
  listDemand: false,
  dashboardSingle: false,
  dashboardAggregate: false,
  policyRenewalList: false,
  agencyRegionCode: 0,
  segment: null
}

var agencyRegion = {
  76: 'Otomotiv',
  12: 'Acente',
  1: 'DogusKurumsalAcenteBroker',
  0: 'Acente'
}

var cascoPolicies = []
var healthPolicyList = []

window.getToken = function () {
  var hashValue = md5('token')
  var tokenStr = localStorage.getItem(hashValue)

  if (tokenStr) {
    var decryptedTokenStr = decryptCodes(tokenStr, hashValue)
    return decryptedTokenStr
  }
  return ''
}

window.setToken = function (value) {
  if (value) {
    var hashValue = md5('token')
    var encryptedToken = encryptCodes(value, hashValue)
    localStorage.setItem(hashValue, encryptedToken)
  }
}

window.getRefreshToken = function () {
  var hashValue = md5('refreshToken')
  var refreshTokenStr = localStorage.getItem(hashValue)

  if (refreshTokenStr) {
    var decryptedRefreshTokenStr = decryptCodes(refreshTokenStr, hashValue)
    return decryptedRefreshTokenStr
  }
  return ''
}

window.setRefreshToken = function (value) {
  var hashValue = md5('refreshToken')
  if (value) {
    var encryptedRefreshToken = encryptCodes(value, hashValue)
    localStorage.setItem(hashValue, encryptedRefreshToken)
  }
}

window.removeCustomerInfo = function () {
  var customer = {
    customerNo: 0,
    name: '',
    surname: '',
    fullName: '',
    birthDate: null,
    identity: '',
    mobilePhone: '',
    businessPhone: '',
    email: '',
    isKolu: '',
    musteriTipi: '',
    identityType: '',
    communication: {
      phoneNumber: '',
      email: '',
      fullAddress: '',
      address: '',
      info: null
    }
  }
  window.setCustomer(customer)
}

window.removeAgencyAuthorizationsInfo = function () {
  var agencyAuthorizations = {
    webLogin: false,
    allBranches: false,
    blPage: false,
    uploadDemand: false,
    listDemand: false,
    dashboardSingle: false,
    dashboardAggregate: false,
    policyRenewalList: false,
    agencyRegionCode: 0,
    segment: null
  }
  window.setAgencyAuthorizations(agencyAuthorizations)
}

window.getCustomer = function () {
  var hashValue = md5('customer')
  var customerStr = localStorage.getItem(hashValue)

  if (customerStr) {
    var decryptedCustomerStr = decryptCodes(customerStr, hashValue)
    return JSON.parse(decryptedCustomerStr)
  }
  return customer
}

window.getAgencyAuthorizations = function () {
  var hashValue = md5('agencyAuthorizations')
  var agencyAuthorizationsStr = localStorage.getItem(hashValue)

  if (agencyAuthorizationsStr) {
    var decryptedAgencyAuthorizationsStr = decryptCodes(agencyAuthorizationsStr, hashValue)
    return JSON.parse(decryptedAgencyAuthorizationsStr)
  }
  return agencyAuthorizations
}

window.getAgencyAuthRegionName = function () {
  var tempAgencyAuthorizations = window.getAgencyAuthorizations()
  return agencyRegion[tempAgencyAuthorizations.agencyRegionCode]
}

window.deleteLoginItems = function () {
  var token = md5('token')
  var refreshToken = md5('refreshToken')
  var customer = md5('customer')
  var refreshRequestCount = md5('refreshRequestCount')
  var lastSuccessRefreshTime = md5('lastSuccessRefreshTime')
  var healthPolicies = md5('healthPolicies')
  var agencyAuthorizations = md5('agencyAuthorizations')
  localStorage.removeItem(token)
  localStorage.removeItem(refreshToken)
  if (window.location.hash !== '#mobile') {
    localStorage.removeItem(customer)
  }
  localStorage.removeItem(agencyAuthorizations)
  localStorage.removeItem(refreshRequestCount)
  localStorage.removeItem(lastSuccessRefreshTime)
  localStorage.removeItem(healthPolicies)
}

window.setPolicyInfo = function (value) {
  if (value) {
    var policies = value
    var hashValue = md5('policies')
    var encryptedCustomer = encryptCodes(JSON.stringify(policies), hashValue)
    localStorage.setItem(hashValue, encryptedCustomer)
  }
}

window.getPolicyInfo = function () {
  var hashValue = md5('policies')
  var policiesStr = localStorage.getItem(hashValue)

  if (policiesStr) {
    var decryptedPoliciesStr = decryptCodes(policiesStr, hashValue)
    return JSON.parse(decryptedPoliciesStr)
  }
  return cascoPolicies
}

window.setHealthPolicy = function (value) {
  if (value) {
    var healthPolicies = value
    var hashValue = md5('healthPolicies')
    var encryptedCustomer = encryptCodes(JSON.stringify(healthPolicies), hashValue)
    localStorage.setItem(hashValue, encryptedCustomer)
  }
}

window.getHealthPolicy = function () {
  var hashValue = md5('healthPolicies')
  var healthPoliciesStr = localStorage.getItem(hashValue)

  if (healthPoliciesStr) {
    var decryptedHealthPoliciesStr = decryptCodes(healthPoliciesStr, hashValue)
    return JSON.parse(decryptedHealthPoliciesStr)
  }
  return healthPolicyList
}

window.setCampaigns = function (value) {
  if (value) {
    var campaigns = value
    var hashValue = md5('campaigns')
    var encryptedCustomer = encryptCodes(JSON.stringify(campaigns), hashValue)
    localStorage.setItem(hashValue, encryptedCustomer)
  }
}

window.getCampaigns = function () {
  var hashValue = md5('campaigns')
  var campaignsStr = localStorage.getItem(hashValue)

  if (campaignsStr) {
    var decryptedcampaignsStr = decryptCodes(campaignsStr, hashValue)
    return JSON.parse(decryptedcampaignsStr)
  }
  return []
}

window.setCustomer = function (value) {
  if (value) {
    customer.customerNo = value['CustomerNo']
    customer.name = value['Name']
    customer.surname = value['Surname']
    customer.fullName = value['Name'] + ' ' + value['Surname']
    customer.birthDate = value['BirthDate']
    customer.identity = value['Identity']
    customer.mobilePhone = value['MobilePhone']
    customer.businessPhone = value['BusinessPhone']
    customer.email = value['Email']
    customer.isKolu = value['Iskolu']
    customer.musteriTipi = value['MusteriTipi']
    customer.identityType = value['IdentityType']
    customer.communication.phoneNumber = value['MobilePhone']
    customer.communication.email = value['Email']
    customer.communication.fullAddress = value['Address'] ? value['Address'].FullAddress : ''
    customer.communication.address = value['Address']
    customer.communication.info = value['CommunicationInfo']
    customer.agencyNo = value['AgencyNo']
    customer.agencyTitle = value['AgencyTitle']
  }

  var hashValue = md5('customer')
  var encryptedCustomer = encryptCodes(JSON.stringify(customer), hashValue)
  localStorage.setItem(hashValue, encryptedCustomer)
}

window.setAgencyAuthorizations = function (value) {
  if (value) {
    agencyAuthorizations.webLogin = value['WebLogin']
    agencyAuthorizations.allBranches = value['AllBranches']
    agencyAuthorizations.blPage = value['BlPage']
    agencyAuthorizations.uploadDemand = value['UploadDemand']
    agencyAuthorizations.listDemand = value['ListDemand']
    agencyAuthorizations.dashboardSingle = value['DashboardSingle']
    agencyAuthorizations.dashboardAggregate = value['DashboardAggregate']
    agencyAuthorizations.policyRenewalList = value['PolicyRenewalList']
    agencyAuthorizations.agencyRegionCode = value['AgencyRegionCode']
    agencyAuthorizations.segment = value['Segment']
  }

  var hashValue = md5('agencyAuthorizations')
  var encryptedAgencyAuth = encryptCodes(JSON.stringify(agencyAuthorizations), hashValue)
  localStorage.setItem(hashValue, encryptedAgencyAuth)
}

window.getNotificationRead = function () {
  var hashValue = md5('notificationRead')
  return localStorage.getItem(hashValue)
}

window.setNotificationRead = function (value) {
  var hashValue = md5('notificationRead')
  localStorage.setItem(hashValue, value)
}

window.getLastSuccessRefreshTime = function () {
  var hashValue = md5('lastSuccessRefreshTime')
  return localStorage.getItem(hashValue)
}

window.setLastSuccessRefreshTime = function (value) {
  var hashValue = md5('lastSuccessRefreshTime')
  localStorage.setItem(hashValue, value)
}

window.getRefreshRequestCount = function () {
  var hashValue = md5('refreshRequestCount')
  return localStorage.getItem(hashValue)
}

window.setRefreshRequestCount = function (value) {
  var hashValue = md5('refreshRequestCount')
  localStorage.setItem(hashValue, value)
}
window.setRefreshRequestCount(0)

window.onbeforeunload = function (event) {
  // console.log('window.onbeforeunload')
  // window.deleteLoginItems()
}

window.setRecaptchaInfo = function (value) {
  if (value) {
    var hashValue = md5('recaptcha')
    var encryptedToken = encryptCodes(value, hashValue)
    localStorage.setItem(hashValue, encryptedToken)
  }
}

window.getRecaptchaInfo = function () {
  var hashValue = md5('recaptcha')
  var tokenStr = localStorage.getItem(hashValue)

  if (tokenStr) {
    var decryptedTokenStr = decryptCodes(tokenStr, hashValue)
    return decryptedTokenStr
  }
  return ''
}

var encryptCodes = function (content, passcode) {
  var result = []; var passLen = passcode.length
  for (var i = 0; i < content.length; i++) {
    var passOffset = i % passLen
    var calAscii = (content.charCodeAt(i) + passcode.charCodeAt(passOffset))
    result.push(calAscii)
  }
  return JSON.stringify(result)
}

var decryptCodes = function (content, passcode) {
  var result = []; var str = ''
  var codesArr = JSON.parse(content); var passLen = passcode.length
  for (var i = 0; i < codesArr.length; i++) {
    var passOffset = i % passLen
    var calAscii = (codesArr[i] - passcode.charCodeAt(passOffset))
    result.push(calAscii)
  }
  for (var j = 0; j < result.length; j++) {
    var ch = String.fromCharCode(result[j]); str += ch
  }
  return str
}



// WEBPACK FOOTER //
// ./src/assets/js/app.js